import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useId } from 'react';
import './prism-surface.css';
const PrismSurface = t0 => {
  const $ = _c(103);
  let children;
  let rest;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t2;
  let t20;
  let t21;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== t0) {
    ({
      children,
      width: t1,
      height: t2,
      borderRadius: t3,
      borderWidth: t4,
      brightness: t5,
      opacity: t6,
      blur: t7,
      displace: t8,
      backgroundOpacity: t9,
      saturation: t10,
      distortionScale: t11,
      redOffset: t12,
      greenOffset: t13,
      blueOffset: t14,
      xChannel: t15,
      yChannel: t16,
      mixBlendMode: t17,
      performanceMode: t18,
      className: t19,
      contentClassName: t20,
      style: t21,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
    $[3] = t1;
    $[4] = t10;
    $[5] = t11;
    $[6] = t12;
    $[7] = t13;
    $[8] = t14;
    $[9] = t15;
    $[10] = t16;
    $[11] = t17;
    $[12] = t18;
    $[13] = t19;
    $[14] = t2;
    $[15] = t20;
    $[16] = t21;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    children = $[1];
    rest = $[2];
    t1 = $[3];
    t10 = $[4];
    t11 = $[5];
    t12 = $[6];
    t13 = $[7];
    t14 = $[8];
    t15 = $[9];
    t16 = $[10];
    t17 = $[11];
    t18 = $[12];
    t19 = $[13];
    t2 = $[14];
    t20 = $[15];
    t21 = $[16];
    t3 = $[17];
    t4 = $[18];
    t5 = $[19];
    t6 = $[20];
    t7 = $[21];
    t8 = $[22];
    t9 = $[23];
  }
  const width = t1 === undefined ? 200 : t1;
  const height = t2 === undefined ? 80 : t2;
  const borderRadius = t3 === undefined ? 20 : t3;
  const borderWidth = t4 === undefined ? 0.07 : t4;
  const brightness = t5 === undefined ? 50 : t5;
  const opacity = t6 === undefined ? 0.93 : t6;
  const blur = t7 === undefined ? 11 : t7;
  const displace = t8 === undefined ? 0 : t8;
  const backgroundOpacity = t9 === undefined ? 0 : t9;
  const saturation = t10 === undefined ? 1 : t10;
  const distortionScale = t11 === undefined ? -180 : t11;
  const redOffset = t12 === undefined ? 0 : t12;
  const greenOffset = t13 === undefined ? 10 : t13;
  const blueOffset = t14 === undefined ? 20 : t14;
  const xChannel = t15 === undefined ? "R" : t15;
  const yChannel = t16 === undefined ? "G" : t16;
  const mixBlendMode = t17 === undefined ? "difference" : t17;
  const performanceMode = t18 === undefined ? false : t18;
  const className = t19 === undefined ? "" : t19;
  const contentClassName = t20 === undefined ? "" : t20;
  let t22;
  if ($[24] !== t21) {
    t22 = t21 === undefined ? {} : t21;
    $[24] = t21;
    $[25] = t22;
  } else {
    t22 = $[25];
  }
  const style = t22;
  const t23 = useId();
  let t24;
  if ($[26] !== t23) {
    let t25;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t25 = /:/g;
      $[28] = t25;
    } else {
      t25 = $[28];
    }
    t24 = t23.replace(t25, "-");
    $[26] = t23;
    $[27] = t24;
  } else {
    t24 = $[27];
  }
  const uniqueId = t24;
  const filterId = `glass-filter-${uniqueId}`;
  const redGradId = `red-grad-${uniqueId}`;
  const blueGradId = `blue-grad-${uniqueId}`;
  const containerRef = useRef(null);
  const feImageRef = useRef(null);
  const redChannelRef = useRef(null);
  const greenChannelRef = useRef(null);
  const blueChannelRef = useRef(null);
  const gaussianBlurRef = useRef(null);
  let t25;
  if ($[29] !== blueGradId || $[30] !== blur || $[31] !== borderRadius || $[32] !== borderWidth || $[33] !== brightness || $[34] !== mixBlendMode || $[35] !== opacity || $[36] !== redGradId) {
    t25 = () => {
      const rect = containerRef.current?.getBoundingClientRect();
      const actualWidth = rect?.width || 400;
      const actualHeight = rect?.height || 200;
      const edgeSize = Math.min(actualWidth, actualHeight) * (borderWidth * 0.5);
      const svgContent = `

      <svg viewBox="0 0 ${actualWidth} ${actualHeight}" xmlns="http://www.w3.org/2000/svg">

        <defs>

          <linearGradient id="${redGradId}" x1="100%" y1="0%" x2="0%" y2="0%">

            <stop offset="0%" stop-color="#0000"/>

            <stop offset="100%" stop-color="red"/>

          </linearGradient>

          <linearGradient id="${blueGradId}" x1="0%" y1="0%" x2="0%" y2="100%">

            <stop offset="0%" stop-color="#0000"/>

            <stop offset="100%" stop-color="blue"/>

          </linearGradient>

        </defs>

        <rect x="0" y="0" width="${actualWidth}" height="${actualHeight}" fill="black"></rect>

        <rect x="0" y="0" width="${actualWidth}" height="${actualHeight}" rx="${borderRadius}" fill="url(#${redGradId})" />

        <rect x="0" y="0" width="${actualWidth}" height="${actualHeight}" rx="${borderRadius}" fill="url(#${blueGradId})" style="mix-blend-mode: ${mixBlendMode}" />

        <rect x="${edgeSize}" y="${edgeSize}" width="${actualWidth - edgeSize * 2}" height="${actualHeight - edgeSize * 2}" rx="${borderRadius}" fill="hsl(0 0% ${brightness}% / ${opacity})" style="filter:blur(${blur}px)" />

      </svg>

    `;
      return `data:image/svg+xml,${encodeURIComponent(svgContent)}`;
    };
    $[29] = blueGradId;
    $[30] = blur;
    $[31] = borderRadius;
    $[32] = borderWidth;
    $[33] = brightness;
    $[34] = mixBlendMode;
    $[35] = opacity;
    $[36] = redGradId;
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  const generateDisplacementMap = t25;
  let t26;
  if ($[38] !== generateDisplacementMap || $[39] !== performanceMode) {
    t26 = () => {
      if (performanceMode) {
        return;
      }
      feImageRef.current?.setAttribute("href", generateDisplacementMap());
    };
    $[38] = generateDisplacementMap;
    $[39] = performanceMode;
    $[40] = t26;
  } else {
    t26 = $[40];
  }
  const updateDisplacementMap = t26;
  const supportsSVGFilters = () => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      return false;
    }
    const isWebkit = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    const isFirefox = /Firefox/.test(navigator.userAgent);
    if (isWebkit || isFirefox) {
      return false;
    }
    const div = document.createElement("div");
    div.style.backdropFilter = `url(#${filterId})`;
    return div.style.backdropFilter !== "";
  };
  let t27;
  if ($[41] !== blueOffset || $[42] !== displace || $[43] !== distortionScale || $[44] !== greenOffset || $[45] !== performanceMode || $[46] !== redOffset || $[47] !== updateDisplacementMap || $[48] !== xChannel || $[49] !== yChannel) {
    t27 = () => {
      if (performanceMode) {
        return;
      }
      updateDisplacementMap();
      [{
        ref: redChannelRef,
        offset: redOffset
      }, {
        ref: greenChannelRef,
        offset: greenOffset
      }, {
        ref: blueChannelRef,
        offset: blueOffset
      }].forEach(t28 => {
        const {
          ref,
          offset
        } = t28;
        if (ref.current) {
          ref.current.setAttribute("scale", (distortionScale + offset).toString());
          ref.current.setAttribute("xChannelSelector", xChannel);
          ref.current.setAttribute("yChannelSelector", yChannel);
        }
      });
      gaussianBlurRef.current?.setAttribute("stdDeviation", displace.toString());
    };
    $[41] = blueOffset;
    $[42] = displace;
    $[43] = distortionScale;
    $[44] = greenOffset;
    $[45] = performanceMode;
    $[46] = redOffset;
    $[47] = updateDisplacementMap;
    $[48] = xChannel;
    $[49] = yChannel;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] !== blueOffset || $[52] !== blur || $[53] !== borderRadius || $[54] !== borderWidth || $[55] !== brightness || $[56] !== displace || $[57] !== distortionScale || $[58] !== greenOffset || $[59] !== height || $[60] !== mixBlendMode || $[61] !== opacity || $[62] !== performanceMode || $[63] !== redOffset || $[64] !== updateDisplacementMap || $[65] !== width || $[66] !== xChannel || $[67] !== yChannel) {
    t28 = [width, height, borderRadius, borderWidth, brightness, opacity, blur, displace, distortionScale, redOffset, greenOffset, blueOffset, xChannel, yChannel, mixBlendMode, performanceMode, updateDisplacementMap];
    $[51] = blueOffset;
    $[52] = blur;
    $[53] = borderRadius;
    $[54] = borderWidth;
    $[55] = brightness;
    $[56] = displace;
    $[57] = distortionScale;
    $[58] = greenOffset;
    $[59] = height;
    $[60] = mixBlendMode;
    $[61] = opacity;
    $[62] = performanceMode;
    $[63] = redOffset;
    $[64] = updateDisplacementMap;
    $[65] = width;
    $[66] = xChannel;
    $[67] = yChannel;
    $[68] = t28;
  } else {
    t28 = $[68];
  }
  useEffect(t27, t28);
  let t29;
  let t30;
  if ($[69] !== performanceMode || $[70] !== updateDisplacementMap) {
    t29 = () => {
      if (performanceMode || !containerRef.current) {
        return;
      }
      const resizeObserver = new ResizeObserver(() => {
        setTimeout(updateDisplacementMap, 0);
      });
      resizeObserver.observe(containerRef.current);
      return () => {
        resizeObserver.disconnect();
      };
    };
    t30 = [performanceMode, updateDisplacementMap];
    $[69] = performanceMode;
    $[70] = updateDisplacementMap;
    $[71] = t29;
    $[72] = t30;
  } else {
    t29 = $[71];
    t30 = $[72];
  }
  useEffect(t29, t30);
  let t31;
  if ($[73] !== performanceMode || $[74] !== updateDisplacementMap) {
    t31 = () => {
      if (performanceMode) {
        return;
      }
      setTimeout(updateDisplacementMap, 0);
    };
    $[73] = performanceMode;
    $[74] = updateDisplacementMap;
    $[75] = t31;
  } else {
    t31 = $[75];
  }
  let t32;
  if ($[76] !== height || $[77] !== performanceMode || $[78] !== updateDisplacementMap || $[79] !== width) {
    t32 = [width, height, performanceMode, updateDisplacementMap];
    $[76] = height;
    $[77] = performanceMode;
    $[78] = updateDisplacementMap;
    $[79] = width;
    $[80] = t32;
  } else {
    t32 = $[80];
  }
  useEffect(t31, t32);
  const t33 = typeof width === "number" ? `${width}px` : width;
  const t34 = typeof height === "number" ? `${height}px` : height;
  const t35 = `${borderRadius}px`;
  const t36 = `url(#${filterId})`;
  let t37;
  if ($[81] !== backgroundOpacity || $[82] !== saturation || $[83] !== style || $[84] !== t33 || $[85] !== t34 || $[86] !== t35 || $[87] !== t36) {
    t37 = {
      ...style,
      width: t33,
      height: t34,
      borderRadius: t35,
      "--glass-frost": backgroundOpacity,
      "--glass-saturation": saturation,
      "--filter-id": t36
    };
    $[81] = backgroundOpacity;
    $[82] = saturation;
    $[83] = style;
    $[84] = t33;
    $[85] = t34;
    $[86] = t35;
    $[87] = t36;
    $[88] = t37;
  } else {
    t37 = $[88];
  }
  const containerStyle = t37;
  const svgSupported = !performanceMode && supportsSVGFilters();
  const surfaceModeClass = performanceMode ? "glass-surface--performance" : svgSupported ? "glass-surface--svg" : "glass-surface--fallback";
  const t38 = `glass-surface ${surfaceModeClass} ${className}`;
  let t39;
  if ($[89] !== filterId || $[90] !== performanceMode) {
    t39 = !performanceMode && <svg className="glass-surface__filter" xmlns="http://www.w3.org/2000/svg"><defs><filter id={filterId} colorInterpolationFilters="sRGB" x="0%" y="0%" width="100%" height="100%"><feImage ref={feImageRef} x="0" y="0" width="100%" height="100%" preserveAspectRatio="none" result="map" /><feDisplacementMap ref={redChannelRef} in="SourceGraphic" in2="map" id="redchannel" result="dispRed" /><feColorMatrix in="dispRed" type="matrix" values={"1 0 0 0 0\n\n                      0 0 0 0 0\n\n                      0 0 0 0 0\n\n                      0 0 0 1 0"} result="red" /><feDisplacementMap ref={greenChannelRef} in="SourceGraphic" in2="map" id="greenchannel" result="dispGreen" /><feColorMatrix in="dispGreen" type="matrix" values={"0 0 0 0 0\n\n                      0 1 0 0 0\n\n                      0 0 0 0 0\n\n                      0 0 0 1 0"} result="green" /><feDisplacementMap ref={blueChannelRef} in="SourceGraphic" in2="map" id="bluechannel" result="dispBlue" /><feColorMatrix in="dispBlue" type="matrix" values={"0 0 0 0 0\n\n                      0 0 0 0 0\n\n                      0 0 1 0 0\n\n                      0 0 0 1 0"} result="blue" /><feBlend in="red" in2="green" mode="screen" result="rg" /><feBlend in="rg" in2="blue" mode="screen" result="output" /><feGaussianBlur ref={gaussianBlurRef} in="output" stdDeviation="0.7" /></filter></defs></svg>;
    $[89] = filterId;
    $[90] = performanceMode;
    $[91] = t39;
  } else {
    t39 = $[91];
  }
  const t40 = `glass-surface__content ${contentClassName}`;
  let t41;
  if ($[92] !== t40) {
    t41 = t40.trim();
    $[92] = t40;
    $[93] = t41;
  } else {
    t41 = $[93];
  }
  let t42;
  if ($[94] !== children || $[95] !== t41) {
    t42 = <div className={t41}>{children}</div>;
    $[94] = children;
    $[95] = t41;
    $[96] = t42;
  } else {
    t42 = $[96];
  }
  let t43;
  if ($[97] !== containerStyle || $[98] !== rest || $[99] !== t38 || $[100] !== t39 || $[101] !== t42) {
    t43 = <div ref={containerRef} className={t38} style={containerStyle} {...rest}>{t39}{t42}</div>;
    $[97] = containerStyle;
    $[98] = rest;
    $[99] = t38;
    $[100] = t39;
    $[101] = t42;
    $[102] = t43;
  } else {
    t43 = $[102];
  }
  return t43;
};
export default PrismSurface;